module.exports = __webpack_public_path__ + "static/img/1.03e7f25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fuwu/1.png
// module id = Zo9W
// module chunks = 1